import * as yup from "yup"

export const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  companyName: "",
  companyWebsite: "",
  address: "",
  address2: "",
  city: "",
  stateProvince: "",
  zip: "",
  country: "",
  industry: "",
  projectStart: "",
  quantityNeeded: "",
  message: "",
  recaptcha: "",
}

export default yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  companyName: yup.string().required("Company name is required"),
  companyWebsite: yup.string(),
  address: yup.string().required("Street address is required"),
  address2: yup.string(),
  city: yup.string().required("City is required"),
  stateProvince: yup.string().required("State or province is required"),
  zip: yup.string().required("Zip or postal code is required"),
  country: yup.string().required("Country is required"),
  industry: yup.string().required("Industry is required"),
  projectStart: yup.string().required("Project timeline is required"),
  quantityNeeded: yup.string().required("Quantity needed is required"),
  message: yup.string().required("Message is required"),
})

export const withRecaptcha = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  companyName: yup.string().required("Company name is required"),
  companyWebsite: yup.string(),
  address: yup.string().required("Street address is required"),
  address2: yup.string(),
  city: yup.string().required("City is required"),
  stateProvince: yup.string().required("State or province is required"),
  zip: yup.string().required("Zip or postal code is required"),
  country: yup.string().required("Country is required"),
  industry: yup.string().required("Industry is required"),
  projectStart: yup.string().required("Project timeline is required"),
  quantityNeeded: yup.string().required("Quantity needed is required"),
  message: yup.string().required("Message is required"),
  recaptcha: yup.string().required(),
})
